import { downloadBlobFromResponse } from "~/common/utils/ApiHelper";
import { occFetch, occUrl } from "~/app/api/occ/occFetch";
import { type QueryType } from "~/features/orders/common/queryTypes";
import { type GroupedAccountsData } from "~/features/orders/common/DownloadOrderHistoryService/types";
import { toMoxyDateNullable, type MoxyDateString } from "~/common/types/MoxyDate";

export enum ReportType {
  CSV = "1",
  XLSX = "0",
}

export interface OrderbookForm {
  filterByOption: QueryType;
  filterByValue: string;
  startDate?: Date;
  endDate?: Date;
  lineStatus?: string;
  deliveryDate?: string;
  account?: GroupedAccountsData;
  accounts?: GroupedAccountsData[];
}

export interface ABMonitorReportRequestWsDTO extends Omit<OrderbookForm, "startDate" | "endDate"> {
  startDate: MoxyDateString | null;
  endDate: MoxyDateString | null;
}

export function toABMonitorReportRequestWsDTO(data: OrderbookForm): ABMonitorReportRequestWsDTO {
  return {
    ...data,
    startDate: toMoxyDateNullable(data.startDate),
    endDate: toMoxyDateNullable(data.endDate),
  };
}

export const downloadOrderbookReport = (data: OrderbookForm, type: ReportType): Promise<void | undefined> => {
  const url = occUrl(`/abmonitor/report/${type}`);

  return occFetch(url, {
    body: JSON.stringify(toABMonitorReportRequestWsDTO(data)),
    method: "POST",
    headers: {
      "content-type": "application/json",
    },
  })
    .then(downloadBlobFromResponse)
    .catch((error) => {
      console.warn(error);
    });
};
